const selectors = {
  form: 'form[data-component="postal-form"]',
  formMessages: 'div[data-component="form-messages"]',
  formSuccessMessage: 'div[data-component="form-success-message"]',
  formErrorMessage: 'div[data-component="form-error-message"]',
  formHeader: 'div[data-component="form-header"]',
  formFields: 'div[data-component="form-fields"]',
  formSubmitButton: 'button[data-component="form-submit-button"]',
  formSuccessButton: 'button[data-hook="postal-form-success-button"]',
  stickyHeader: 'header.sticky-header, [data-sticky-header="on-scroll-up"]',
  mobileMenu: 'div[data-component="mobile-menu"]',
  mobileMenuToggle: 'button[data-component="mobile-menu-toggle"]',
  mobileMenuClose: 'button[data-component="mobile-menu-close"]',
}

const $cache = {
  reviews: [],
  heatingInstructions: [],
  heatingInstructionsNodes: [],
}

const helpers = {
  handleReCaptchaV3: (form, formType) => {
    if (window.grecaptcha && window.Shopify.recaptchaV3) {
      grecaptcha
        .execute(window.Shopify.recaptchaV3.siteKey, {
          action: formType,
        })
        .then(function (token) {
          let recaptchaInput = form.querySelector('input[name=recaptcha-v3-token]')
          recaptchaInput instanceof HTMLElement
            ? recaptchaInput.setAttribute('value', token)
            : ((recaptchaInput = document.createElement('input')).setAttribute('name', 'recaptcha-v3-token'),
              recaptchaInput.setAttribute('type', 'hidden'),
              recaptchaInput.setAttribute('value', token),
              form.appendChild(recaptchaInput, form))

          klaviyo.submitForm(formData)
        })
    } else {
      // Do we need to wait for grecaptcha to load instead?
      klaviyo.submitForm(formData)
    }
  },
  scrollToTop: () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  getZonesJSON: function () {
    const $script = document.querySelector('script[type="application/json"][data-hook="menu-zones"]')

    return JSON.parse($script.innerHTML)
  },
  getActiveZone: function () {
    const zonesJSON = helpers.getZonesJSON();
    const customerZip = localStorage.getItem('customer-zip-code');
    const activeZones = zonesJSON.filter((menuZone) => {
      const menuZoneZips = menuZone.json_zips || menuZone.postal_code;
      return !!menuZoneZips && menuZoneZips.includes(customerZip)
    })

    // Return the first active zone
    return activeZones[0];
  },
  toggleModal: (modalId) => {

    const modalRoot = document.querySelector('#modal-root');
    const modalContent = modalRoot.querySelector('.modal-content');
    const content = document.querySelector(`[data-modal-id="${modalId}"]`);

    if (content) {
      modalContent.innerHTML = content.innerHTML;

      klaviyo.loadForms()

      if (modalRoot.classList.contains('opacity-0')) {
        modalRoot.classList.remove('opacity-0');
        modalRoot.classList.remove('z-[-10]');
      } else {
        modalRoot.classList.add('opacity-0');
        modalRoot.classList.add('z-[-10]');
      }

      // Add the close listener
      const modalClose = modalRoot.querySelector('.modal-close');
      modalClose.addEventListener('click', () => {
        helpers.toggleModal(modalId);
      });

      // Add the escape key listener
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          helpers.toggleModal(modalId);
        }
      });

      // Add the click outside listener
      modalRoot.addEventListener('click', (e) => {
        if (e.target === modalRoot) {
          helpers.toggleModal(modalId);
        }
      });
    } else {
      console.error('[modal] modal not found', modalId);
    }

  },
  freezeScroll: () => {
    document.body.style.overflow = 'hidden';
  },
  unfreezeScroll: () => {
    document.body.style.overflow = 'auto';
  }
}

const klaviyo = {
  loadForms: () => {
    const postalForms = document.querySelectorAll(selectors.form);
    console.log('[klaviyo] loading forms', postalForms);
    postalForms.forEach(form => {

      // Set the form action to empty string to prevent default form submission
      form.setAttribute('action', '');
      console.log('[postal form] adding submit listener', form);
      form.addEventListener('submit', function (e) {
        console.log('[postal form] submitting', e);
        e.preventDefault();
        // Get form data
        const formData = new FormData(form);
        // Set the form data in LocalStorage
        localStorage.setItem('customer-email', formData.get('contact[email]'));
        localStorage.setItem('customer-phone', formData.get('contact[phone]'));
        localStorage.setItem('customer-zip-code', formData.get('contact[zip]'));

        // Submit form data to Klaviyo
        console.log('[submitted form]', formData);
        // helpers.handleReCaptchaV3(form, 'postal-form');
        // return false;
        klaviyo.submitForm(formData);
      });
    });
  },
  submitForm: async (formData) => {

    // Klaviyo Headers
    const headers = {
      accept: 'application/json',
      revision: '2024-02-15',
      'content-type': 'application/json',
    }

    // Klaviyo URL
    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=SQGbsY'
    console.log('[klaviyo] submitting form', formData);
    // Form Data
    const email = formData.get('contact[email]');
    const phone = formData.get('contact[phone]');
    const zip = formData.get('contact[zip]');
    const source = formData.get('contact[source]');
    const listId = formData.get('contact[listId]');
    const preventRedirect = formData.get('contact[preventRedirect]');
    const subscriptionCustomer = formData.get('contact[subscriptionCustomer]');
    const successRedirectUrl = formData.get('contact[successRedirectUrl]');

    // UTM Params & active zone
    const utmParams = new URLSearchParams(window.location.search)
    const utmProperties = {}
    const activeZone = helpers.getActiveZone();

    console.log("utmParams", utmParams.entries())

    for (const [key, value] of utmParams.entries()) {
      console.log("key", key, "value", value)
      if (key.toLowerCase().indexOf("utm") > -1) {
        utmProperties[key.toLowerCase()] = value
      }
    }

    const data = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Shopify Menu Sign-Up',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                phone_number: phone,
                location: {
                  zip: zip,
                },
                properties: {
                  ...utmProperties,
                  menu_zone_name: activeZone?.title,
                  menu_zone_type: activeZone?.menu_type,
                  menu_zone_handle: activeZone?.handle,
                  "Subscription Customer": subscriptionCustomer || activeZone?.menu_type === 'Subscription',
                }
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId || 'RDDpWW',
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    }

    console.log('[klaviyo] submitting data', data);

    // Event Id
    const eventId = crypto.randomUUID();

    /* GTM Tracking */
    gtag('set', 'user_data', {
      "email": email,
      "phone_number": phone,
      "address": {
        "postal_code": zip,
      }
    });
    dataLayer.push({
      event: 'ga_event',
      event_name: 'generate_lead',
      currency: 'USD',
      value: 0,
      event_id: eventId,
      email: email,
      phone_number: phone,
      address: {
        postal_code: zip,
      },
      zip: zip,
    });

    if (preventRedirect == 'true') {
      // Set the success button to redirect to the new url
      const formSuccessButton = document.querySelector(selectors.formSuccessButton);
      formSuccessButton.addEventListener('click', () => {
        window.location.href = successRedirectUrl;
      });

      // Hide the form
      const formFields = document.querySelector(selectors.formFields);
      const formHeader = document.querySelector(selectors.formHeader);
      formFields?.classList.add('hidden');
      formHeader?.classList.add('hidden');

      // Show the success message
      const formMessages = document.querySelector(selectors.formMessages);
      const formSuccessMessage = document.querySelector(selectors.formSuccessMessage);
      formMessages?.classList.remove('hidden');
      formSuccessMessage?.classList.remove('hidden');
    } else {
      window.location.href = successRedirectUrl;
    }

  }
}

const okendo = {
  getReviews: async (subscriberId, reviewCount) => {
    $cache.reviews = [];
    const baseUrl = `https://api.okendo.io/v1/stores/${subscriberId}`;
    const url = `${baseUrl}/reviews`

    const fetchReviews = async (nextUrl) => {
      await fetch(nextUrl)
        .then(response => {
          return response.json()
        })
        .then(data => {
          $cache.reviews.push(...data.reviews);
          if (data.nextUrl && $cache.reviews.length < reviewCount) {
            const fetchUrl = `${baseUrl}/${data.nextUrl.split("/").pop()}`
            return fetchReviews(fetchUrl);
          } else {
            return $cache.reviews;
          }
        })
        .catch(err => console.error(err));
    }

    await fetchReviews(url);
    return $cache.reviews;
  },
  getProductReviews: async (subscriberId, productId, reviewCount = 100) => {
    $cache.reviews = [];
    const baseUrl = `https://api.okendo.io/v1/stores/${subscriberId}/products/${productId}`;

    const fetchReviews = async (nextUrl) => {
      await fetch(nextUrl)
        .then(response => {
          return response.json()
        })
        .then(data => {
          $cache.reviews.push(...data.reviews);
          if (data.nextUrl && $cache.reviews.length < reviewCount) {
            const fetchUrl = `${baseUrl}/${data.nextUrl.split("/").pop()}`
            return fetchReviews(fetchUrl);
          } else {
            return $cache.reviews;
          }
        })
        .catch(err => console.error(err));
    }

    await fetchReviews(`${baseUrl}/reviews`);
    return $cache.reviews;
  },
  filterReviews: (wrapper, reviews) => {
    const starIcon = document.querySelector('[data-okendo-star-icon]');
    wrapper.innerHTML = reviews?.filter(review => review.status === 'approved').map(review => {
      return okendo.reviewTemplate(review, starIcon);
    }).join('');
  },
  reviewTemplate: (review, starIcon) => {
    const stars = Array.from({ length: review.rating }, () => `<img src="${starIcon.src}" alt="Star Icon" class="w-4 h-4" width="40" height="40" data-okendo-star-icon>`).join('');
    return `
        <div class="okendo-review flex flex-col gap-4 bg-white border-[1.5px] border-black">
          <div class="okendo-review-header flex flex-row justify-between gap-4 border-b-[1.5px] border-black">
            <div class="okendo-review-product-image flex-1 overflow-hidden border-r-[1.5px] border-black" style="aspect-ratio: 1/1; border-right: 1.5px solid black;">
              <img src="${review.productImageUrl}" alt="Product Image" class="w-full h-full object-cover">
            </div>
            <div class="okendo-review-rating-wrapper flex flex-col gap-2 py-4 pr-4" style="flex: 2; padding-right: 16px;">
              <div class="okendo-review-product font-marr-sans text-lg">${review.productName}</div>
              <div class="okendo-review-rating flex items-center gap-1">
                ${stars}
              </div>
            </div>
          </div>
          <div class="okendo-review-body flex flex-col gap-2 px-4" style="padding-bottom: 16px;">
            <div class="okendo-review-title text-xl">${review.title}</div>
            <div class="okendo-review-content">${review.body}</div>
            <div class="okendo-review-author text-sm font-semibold">- ${review.reviewer.displayName}</div>
          </div>
        </div>
      `
  },
  loadReviews: async (subscriberId, container) => {
    $cache.reviews = await okendo.getReviews(subscriberId, 100);
    console.log('[okendo] reviews', $cache.reviews);
    const wrapper = document.querySelector(container);
    const starIcon = document.querySelector('[data-okendo-star-icon]');
    wrapper.innerHTML = $cache.reviews?.filter(review => review.status === 'approved').map(review => {
      return okendo.reviewTemplate(review, starIcon);
    }).join('');

    // Load search and filters
    const searchInput = document.querySelector('[data-okendo-search]');
    const products = $cache.reviews?.map(review => {
      return {
        productName: review.productName,
        productId: review.productId,
      }
    }).filter((value, index, self) => self.findIndex(v => v.productId === value.productId) === index).sort((a, b) => a.productName.localeCompare(b.productName)); // Unique products
    const ratings = $cache.reviews?.map(review => review.rating).filter((value, index, self) => self.indexOf(value) === index); // Unique ratings
    const sortOptions = {
      'Newest': 'dateCreated',
      'Oldest': '-dateCreated',
      'Highest Rating': 'rating',
      'Lowest Rating': '-rating',
    }

    // Make sure we've got fuse.js loaded
    const fuse = new Fuse($cache.reviews, {
      keys: ['title', 'body', 'productName'],
    });

    // Add the search listener
    searchInput.addEventListener('input', () => {
      const results = (fuse.search(searchInput.value)).map(result => result.item);
      if (results.length > 0) {
        okendo.filterReviews(wrapper, results);
      } else {
        okendo.filterReviews(wrapper, $cache.reviews);
      }
      helpers.scrollToTop();
    });

    // Add the possible options to the filters
    const productsSelect = document.querySelector('[name="reviews-filters-product"]');
    const ratingsSelect = document.querySelector('[name="reviews-filters-rating"]');
    const sortingSelect = document.querySelector('[name="reviews-sorting"]');

    if (productsSelect) {
      let defaultOption = `<option value="">All Products</option>`;
      productsSelect.innerHTML = defaultOption + products?.map(product => `<option value="${product.productId}">${product.productName}</option>`).join('');
    }
    if (ratingsSelect) {
      let defaultOption = `<option value="">All Ratings</option>`;
      ratingsSelect.innerHTML = defaultOption + ratings?.map(rating => `<option value="${rating}">${rating}</option>`).join('');
    }
    if (sortingSelect) {
      let defaultOption = `<option value="">Sort by</option>`;
      sortingSelect.innerHTML = defaultOption + Object.entries(sortOptions).map(([key, value]) => `<option value="${value}">${key}</option>`).join('');
    }

    // Add the product filter listener
    productsSelect.addEventListener('change', async () => {
      const productId = productsSelect.value;

      if (productId !== '') {
        $cache.reviews = await okendo.getProductReviews(subscriberId, productId, 100);
        okendo.filterReviews(wrapper, $cache.reviews);
      } else {
        $cache.reviews = await okendo.getReviews(subscriberId, 100);
        okendo.filterReviews(wrapper, $cache.reviews);
      }
      helpers.scrollToTop();
    });

    // Add the rating filter listener
    ratingsSelect.addEventListener('change', async () => {
      const rating = ratingsSelect.value;
      let filteredReviews = [];
      if (productsSelect.value !== '') {
        $cache.reviews = await okendo.getProductReviews(subscriberId, productsSelect.value, 100);
        filteredReviews = $cache.reviews?.filter(review => review.rating == rating);
      } else {
        $cache.reviews = await okendo.getReviews(subscriberId, 100);
        filteredReviews = $cache.reviews?.filter(review => review.rating == rating);
      }
      okendo.filterReviews(wrapper, filteredReviews);
      helpers.scrollToTop();
    });

    // Add the sorting listener
    sortingSelect.addEventListener('change', () => {
      const sort = sortingSelect.value;
      const sortKey = sort.replace('-', '');
      let sortedReviews = [];
      if (!sort.includes('-')) {
        sortedReviews = Array.from($cache.reviews).sort((a, b) => {
          if (sortKey === 'rating') {
            return b[sortKey] - a[sortKey];
          }
          return b[sortKey].localeCompare(a[sortKey]);
        });
      } else {
        console.log('[okendo] ascending');
        sortedReviews = Array.from($cache.reviews).sort((a, b) => {
          if (sortKey === 'rating') {
            return a[sortKey] - b[sortKey];
          }
          return a[sortKey].localeCompare(b[sortKey]);
        });
      }
      okendo.filterReviews(wrapper, sortedReviews);
      helpers.scrollToTop();
    });

  },
}

const listeners = {
  stickyHeader: () => {
    /**
     * Sticky Nav
     * Handle sliding up the header when scrolling down and vice versa.
     * gnu-site-header opts in through its "Sticky header" setting.
     */
    const mobileMenu = document.querySelector(selectors.mobileMenu);
    // Looked up on each frame so a section re-render in the theme editor is picked up
    const getStickyHeader = () => document.querySelector(selectors.stickyHeader)?.closest('.shopify-section');
    let lastScrollY = window.scrollY;
    let ticking = false;

    const update = () => {
      ticking = false;
      const stickyHeader = getStickyHeader();
      if (!stickyHeader) return;

      // Clamp so the iOS overscroll bounce at either end doesn't count as a change of direction
      const maxScrollY = document.documentElement.scrollHeight - window.innerHeight;
      const currentScrollY = Math.min(Math.max(window.scrollY, 0), maxScrollY);
      if (Math.abs(currentScrollY - lastScrollY) < 5) return;

      // The mobile menu is position: fixed inside the header, so never move the header while it is open
      const menuOpen = mobileMenu?.classList.contains('translate-x-0');
      if (currentScrollY > lastScrollY && currentScrollY > stickyHeader.offsetHeight && !menuOpen) {
        stickyHeader.classList.add('-translate-y-full');
      } else if (currentScrollY < lastScrollY) {
        stickyHeader.classList.remove('-translate-y-full');
      }
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });

    // Bring the header back when keyboard focus moves into it
    document.addEventListener('focusin', (event) => {
      const stickyHeader = getStickyHeader();
      if (stickyHeader?.contains(event.target)) {
        stickyHeader.classList.remove('-translate-y-full');
      }
    });
  },
  mobileMenu: () => {
    /**
     * Mobile Menu
     */
    const mobileMenu = document.querySelector(selectors.mobileMenu);
    const mobileMenuToggle = document.querySelectorAll(selectors.mobileMenuToggle);
    const mobileMenuClose = document.querySelectorAll(selectors.mobileMenuClose);
    mobileMenuToggle?.forEach(button => {
      button.addEventListener('click', () => {
        helpers.freezeScroll();
        mobileMenu?.classList.toggle('translate-x-0');
      });
    });
    mobileMenuClose?.forEach(button => {
      button.addEventListener('click', () => {
        mobileMenu?.classList.toggle('translate-x-0');
        helpers.unfreezeScroll();
      });
    });
  },
  headerCtaSmoothScroll: () => {
    /**
     * Header CTA Smooth Scroll
     * On product pages, clicking "Try Hark Today" CTA should smooth scroll to top
     */
    const isProductPage = window.location.pathname.includes('/products/');
    const headerCtas = document.querySelectorAll('[data-component="header-cta"]');
    
    if (isProductPage && headerCtas.length > 0) {
      headerCtas.forEach(cta => {
        const ctaText = cta.getAttribute('data-cta-text');
        
        // Check if this is a "Try Hark Today" CTA
        if (ctaText && (ctaText.includes('Try Hark Today') || ctaText.includes('Get Hark'))) {
          cta.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Smooth scroll to top of the page
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          });
        }
      });
    }
  },
  okendoReviews: () => {
    /**
     * Okendo Reviews
     */
    const okendoSubscriberId = document.querySelector('[data-okendo-subscriber-id]');
    console.log('[okendo] subscriber id', okendoSubscriberId);
    if (okendoSubscriberId) {
      // Load Okendo Reviews
      okendo.loadReviews(okendoSubscriberId.getAttribute('data-okendo-subscriber-id'), '.okendo-reviews-container');
    }
  },
  heatingInstructions: () => {
    /**
     * Heating Instructions List
     */
    const heatingInstructionsList = document.querySelector('[data-component="heating-instructions-list"]');
    if (heatingInstructionsList) {

      $cache.heatingInstructionsNodes = document.querySelectorAll('[data-heating-instructions-item]')
      const rawValues = heatingInstructionsList.getAttribute('data-values');
      $cache.heatingInstructions = JSON.parse(rawValues);

      // Hide or show the items based on the search input
      const searchInput = document.querySelector('[data-heating-instructions-search]');
      searchInput?.addEventListener('input', () => {
        const fuse = new Fuse($cache.heatingInstructions, {
          keys: ['title'],
          includeScore: true,
        });
        const results = fuse.search(searchInput.value);
        // Remove all children from the heating instructions list
        heatingInstructionsList.innerHTML = '';
        if (results.length > 0) {
          const sortedResults = results.sort((a, b) => {
            return a.score - a.score;
          });
          // Insert the nodes that are in the results
          sortedResults.forEach(item => {
            let matchedNode;
            $cache.heatingInstructionsNodes.forEach(node => {
              if (node.getAttribute('data-heating-instructions-item') === item.item.handle) {
                matchedNode = node;
              }
            });
            if (matchedNode) {
              heatingInstructionsList.appendChild(matchedNode);
            }
          });
        } else {
          // Add all nodes back to the list
          $cache.heatingInstructionsNodes.forEach(node => {
            heatingInstructionsList.appendChild(node);
          });
        }
        helpers.scrollToTop();
      });
    }
  },
  productCardModal: () => {
    /**
     * Product Card Modal
     */
    const productCards = document.querySelectorAll('[data-modal-id]');
    productCards.forEach(card => {
      card.addEventListener('click', () => {
        console.log('[product card] clicked', card);
        helpers.toggleModal(card.getAttribute('data-modal-id'));
      });
    });
  },
  blogPostSignupForm: () => {
    /**
     * Blog Post Signup Form
     */
    const blogPost = document.querySelector('[data-component="blog-post"]');
    if (blogPost) {
      const blogPostContent = blogPost.querySelector('[data-component="blog-post-content"]');
      const templateShortcodes = [
        "signup_form",
        "image_gallery",
        "cta"
      ]
      
      // Replace the shortcodes with the actual content
      templateShortcodes.forEach(shortcode => {
        // Match the shortcode in the blog post content
        const shortcodeString = `<p>\\[${shortcode}\\]<\/p>`;
        const shortcodeRegex = new RegExp(shortcodeString);
        // Get the content inside the shortcode
        const shortcodeContent = blogPost.querySelector(`[data-template="${shortcode}"]`)?.innerHTML;

        if (shortcodeContent) {
          // Replace the shortcode with the actual content
          blogPostContent.innerHTML = blogPostContent.innerHTML.replace(shortcodeRegex, shortcodeContent);
          // if the shortcode is the signup form, reinitialize the Klaviyo Forms
          if (shortcode == 'signup_form') {
            console.log('[blog post] reinitializing Klaviyo Forms');
            setTimeout(() => {
              klaviyo.loadForms();
            }, 100);
          }
        } else {
          // Check if there is a match for the shortcode in the content
          const match = blogPostContent.innerHTML.match(shortcodeRegex);
          if (match) {
            console.error('[blog post][missing_content] shortcode:', shortcode);
            blogPostContent.innerHTML = blogPostContent.innerHTML.replace(shortcodeRegex, '');
          } else {
            console.error('[blog post][no_match] shortcode:', shortcode);
          }
        }
      });
    }
  }
}

const main = {
  addListeners: () => {
    document.addEventListener('DOMContentLoaded', function () {
      /**
       * Load any in-page Klaviyo Forms
       */
      klaviyo.loadForms()

      /**
       * Add Listeners
       * - Some listeners will reload the Klaviyo Forms
       */
      listeners.stickyHeader();
      listeners.mobileMenu();
      listeners.headerCtaSmoothScroll();
      listeners.okendoReviews();
      listeners.heatingInstructions();
      listeners.productCardModal();
      listeners.blogPostSignupForm();
      
    })
  },
  init: () => {
    console.log('[main] initializing', window.location.pathname);
    if (window.location.pathname.includes('account')) {
      window.location.href = 'https://app.getmakings.com/account/home';
    } else {
      main.addListeners();
    }
  }
}

main.init();
